var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"l-background-animations",attrs:{"id":"ui-background-animations"}},[(_vm.blob)?_c('BlobSnowflakes'):_vm._e(),(_vm.animateTachyons)?_c('TachyonParticles'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }